document.addEventListener('DOMContentLoaded', () => {
  document.documentElement.classList.remove('no-js');
  const navToggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#SiteNav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', () => {
      const open = navToggle.getAttribute('aria-expanded') === 'true';
      navToggle.setAttribute('aria-expanded', String(!open));
      nav.classList.toggle('is-open', !open);
      const accountLink = document.querySelector('.site-nav__account');
      if (accountLink) accountLink.classList.toggle('is-visible', !open);
    });
  }

  const filterToggle = document.querySelector('.filter-toggle');
  const filters = document.querySelector('#CollectionFilters');
  if (filterToggle && filters) {
    filterToggle.addEventListener('click', () => {
      const open = filterToggle.getAttribute('aria-expanded') === 'true';
      filterToggle.setAttribute('aria-expanded', String(!open));
      filters.classList.toggle('is-open', !open);
    });
  }

  const productGallery = document.querySelector('[data-product-gallery]');
  if (productGallery) {
    const showProductMedia = (mediaId) => {
      const panels = productGallery.querySelectorAll('[data-product-media-id]');
      const thumbs = productGallery.querySelectorAll('.product-thumb[data-media-id]');
      panels.forEach((panel) => {
        const active = String(panel.dataset.productMediaId) === String(mediaId);
        panel.hidden = !active;
        if (!active) {
          panel.querySelectorAll('video').forEach((video) => video.pause());
        }
      });
      thumbs.forEach((thumb) => {
        const active = String(thumb.dataset.mediaId) === String(mediaId);
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-pressed', String(active));
      });
    };
    productGallery.showMedia = showProductMedia;
    productGallery.querySelectorAll('.product-thumb[data-media-id]').forEach((thumb) => {
      thumb.addEventListener('click', () => showProductMedia(thumb.dataset.mediaId));
    });
  }

  document.querySelectorAll('.product-recommendations[data-url]').forEach((section) => {
    const loadRecommendations = () => {
      fetch(section.dataset.url)
        .then((response) => response.ok ? response.text() : Promise.reject())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const incoming = html.querySelector('.product-recommendations');
          if (incoming && incoming.innerHTML.trim()) section.innerHTML = incoming.innerHTML;
        })
        .catch(() => {});
    };
    if (!('IntersectionObserver' in window)) {
      loadRecommendations();
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      observer.disconnect();
      loadRecommendations();
    }, { rootMargin: '0px 0px 300px 0px' });
    observer.observe(section);
  });
});
// v14: reset the compact menu cleanly after rotation or navigation.
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('.nav-toggle');
  const nav = document.querySelector('#SiteNav');
  if (!toggle || !nav) return;

  const closeMenu = (restoreFocus = false) => {
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    const submenuSummary = nav.querySelector('details[open] > summary');
    toggle.setAttribute('aria-expanded', 'false');
    nav.classList.remove('is-open');
    document.querySelector('.site-nav__account')?.classList.remove('is-visible');
    nav.querySelectorAll('details[open]').forEach((details) => { details.open = false; });
    if (restoreFocus && wasOpen) toggle.focus();
    else if (restoreFocus && submenuSummary && nav.contains(document.activeElement)) submenuSummary.focus();
  };

  nav.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu()));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeMenu(true);
  });
  // Only one main-navigation disclosure stays open at a time.
  const menuGroups = Array.from(nav.children).filter((node) => node.tagName === 'DETAILS');
  menuGroups.forEach((group) => group.addEventListener('toggle', () => {
    if (group.open) menuGroups.forEach((other) => { if (other !== group) other.open = false; });
  }));

  let previousWideState = window.matchMedia('(min-width: 1200px) and (hover: hover)').matches;
  window.addEventListener('resize', () => {
    const wideState = window.matchMedia('(min-width: 1200px) and (hover: hover)').matches;
    if (wideState !== previousWideState) closeMenu();
    previousWideState = wideState;
  }, { passive: true });
});

// v21: accessible, touch-friendly rotating eBay feedback carousel.
(() => {
  const initialiseEbayCarousels = (scope = document) => {
    scope.querySelectorAll('[data-ebay-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialised === 'true') return;
      carousel.dataset.initialised = 'true';

      const slides = Array.from(carousel.querySelectorAll('[data-ebay-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-ebay-dot]'));
      const previous = carousel.querySelector('[data-ebay-prev]');
      const next = carousel.querySelector('[data-ebay-next]');
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const delay = Number(carousel.dataset.autoplay) || 6000;
      let activeIndex = 0;
      let timer = null;
      let touchStartX = null;

      if (slides.length < 2) return;

      const showSlide = (index, userInitiated = false) => {
        activeIndex = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === activeIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
        });
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', String(active));
        });
        if (userInitiated) restart();
      };

      const stop = () => {
        if (timer) window.clearInterval(timer);
        timer = null;
      };

      const start = () => {
        stop();
        if (!reduceMotion && !document.hidden) {
          timer = window.setInterval(() => showSlide(activeIndex + 1), delay);
        }
      };

      const restart = () => {
        stop();
        start();
      };

      previous?.addEventListener('click', () => showSlide(activeIndex - 1, true));
      next?.addEventListener('click', () => showSlide(activeIndex + 1, true));
      dots.forEach((dot) => dot.addEventListener('click', () => showSlide(Number(dot.dataset.ebayDot), true)));

      carousel.addEventListener('mouseenter', stop);
      carousel.addEventListener('mouseleave', start);
      carousel.addEventListener('focusin', stop);
      carousel.addEventListener('focusout', (event) => {
        if (!carousel.contains(event.relatedTarget)) start();
      });

      carousel.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
        stop();
      }, { passive: true });

      carousel.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const touchEndX = event.changedTouches[0]?.clientX ?? touchStartX;
        const distance = touchEndX - touchStartX;
        if (Math.abs(distance) > 45) showSlide(activeIndex + (distance < 0 ? 1 : -1), true);
        touchStartX = null;
        start();
      }, { passive: true });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stop();
        else start();
      });

      showSlide(0);
      start();
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialiseEbayCarousels());
  document.addEventListener('shopify:section:load', (event) => initialiseEbayCarousels(event.target));
})();

// v24: predictive search, AJAX cart, live variant updates, sticky mobile ATC,
// recently viewed, cart quantity auto-update. All progressive enhancements.
(() => {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = document.body?.dataset.currency || 'GBP';
  const money = (cents) => {
    try {
      return new Intl.NumberFormat('en-GB', { style: 'currency', currency }).format(cents / 100);
    } catch (error) {
      return '£' + (cents / 100).toFixed(2);
    }
  };

  /* ---------- Toast + cart badge ---------- */
  let toastTimer = null;
  const showToast = (message, withCartLink = true) => {
    let toast = document.querySelector('.cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.setAttribute('aria-atomic', 'true');
      document.body.appendChild(toast);
    }
    toast.innerHTML = '';
    const check = document.createElement('span');
    check.className = 'cart-toast__check';
    check.setAttribute('aria-hidden', 'true');
    check.textContent = withCartLink ? '\u2713' : '!';
    toast.appendChild(check);
    const text = document.createElement('span');
    text.className = 'cart-toast__message';
    text.textContent = message;
    toast.appendChild(text);
    if (withCartLink) {
      const link = document.createElement('a');
      link.className = 'cart-toast__link';
      link.href = root + 'cart';
      link.textContent = 'View cart';
      toast.appendChild(link);
    }
    toast.classList.add('is-visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(() => toast.classList.remove('is-visible'), 6000);
  };

  const updateCartCount = (count) => {
    const cartLink = document.querySelector('.header-cart');
    if (!cartLink) return;
    cartLink.setAttribute('aria-label', 'Cart with ' + count + ' items');
    const iconWrap = cartLink.querySelector('.header-cart__icon');
    let badge = iconWrap ? iconWrap.querySelector('b') : null;
    if (count > 0) {
      if (!badge && iconWrap) {
        badge = document.createElement('b');
        iconWrap.appendChild(badge);
      }
      if (badge) badge.textContent = count;
    } else if (badge) {
      badge.remove();
    }
  };

  /* ---------- AJAX add to cart ---------- */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (!window.fetch || !window.FormData) return; // fall back to normal submit
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const originalText = button ? button.textContent : '';
    if (button) {
      button.disabled = true;
      button.textContent = 'Adding…';
    }

    const data = new FormData(form);
    fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then((response) => {
        if (!response.ok) return response.json().then((body) => Promise.reject(body));
        return response.json();
      })
      .then((item) => fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then((response) => response.json())
        .then((cart) => {
          updateCartCount(cart.item_count);
          showToast((item.product_title || 'Item') + ' added to cart');
        }))
      .catch((error) => {
        showToast((error && error.description) || 'Could not add to cart. Please try again.', false);
      })
      .finally(() => {
        if (button) {
          button.disabled = false;
          button.textContent = originalText;
        }
      });
  });

  /* ---------- Predictive search ---------- */
  const searchWrap = document.querySelector('[data-predictive-search]');
  if (searchWrap) {
    const input = searchWrap.querySelector('input[type="search"]');
    const results = searchWrap.querySelector('.predictive-search');
    const status = searchWrap.querySelector('#PredictiveSearchStatus');
    let debounceTimer = null;
    let lastQuery = '';

    const close = () => {
      if (!results) return;
      results.hidden = true;
      results.innerHTML = '';
      if (input) input.setAttribute('aria-expanded', 'false');
    };

    const render = (products, query) => {
      if (!results) return;
      results.innerHTML = '';
      if (!products.length) {
        close();
        if (status) status.textContent = 'No product suggestions for ' + query;
        return;
      }
      const list = document.createElement('ul');
      list.className = 'predictive-search__list';
      products.slice(0, 6).forEach((product) => {
        const item = document.createElement('li');
        const link = document.createElement('a');
        link.href = product.url;
        link.className = 'predictive-search__item';
        const imageUrl = product.featured_image && (product.featured_image.url || product.featured_image.src || product.featured_image);
        if (imageUrl && typeof imageUrl === 'string') {
          const img = document.createElement('img');
          img.src = imageUrl;
          img.alt = '';
          img.loading = 'lazy';
          img.width = 44;
          img.height = 44;
          link.appendChild(img);
        }
        const meta = document.createElement('span');
        const title = document.createElement('strong');
        title.textContent = product.title;
        meta.appendChild(title);
        if (product.price) {
          const price = document.createElement('small');
          price.textContent = String(product.price).indexOf('£') === -1 && !isNaN(Number(product.price))
            ? money(Math.round(Number(product.price) * 100))
            : product.price;
          meta.appendChild(price);
        }
        link.appendChild(meta);
        item.appendChild(link);
        list.appendChild(item);
      });
      const all = document.createElement('a');
      all.className = 'predictive-search__all';
      all.href = root + 'search?type=product&q=' + encodeURIComponent(query);
      all.textContent = 'See all results for “' + query + '”';
      results.appendChild(list);
      results.appendChild(all);
      results.hidden = false;
      if (input) input.setAttribute('aria-expanded', 'true');
      if (status) status.textContent = products.length + ' product suggestions shown';
    };

    const search = (query) => {
      if (results && results.hidden) {
        results.innerHTML = '<div class="predictive-search__loading" aria-hidden="true"><span></span><span></span><span></span></div>';
        results.hidden = false;
      }
      const params = new URLSearchParams({
        q: query,
        'resources[type]': 'product',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'last',
        'resources[options][fields]': 'title,vendor,product_type,tag,variants.sku'
      });
      fetch(root + 'search/suggest.json?' + params.toString(), { headers: { Accept: 'application/json' } })
        .then((response) => (response.ok ? response.json() : Promise.reject()))
        .then((data) => {
          if (query !== lastQuery) return;
          const products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          render(products, query);
        })
        .catch(() => close());
    };

    if (input) {
      input.addEventListener('input', () => {
        const query = input.value.trim();
        lastQuery = query;
        window.clearTimeout(debounceTimer);
        if (query.length < 2) {
          close();
          return;
        }
        debounceTimer = window.setTimeout(() => search(query), 220);
      });
      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowDown' && results && !results.hidden) {
          const first = results.querySelector('a');
          if (first) {
            event.preventDefault();
            first.focus();
          }
        }
      });
    }
    // Suggestions remain normal links; support arrow keys and return focus on Escape.
    results?.addEventListener('keydown', (event) => {
      const links = Array.from(results.querySelectorAll('a'));
      const index = links.indexOf(document.activeElement);
      if (event.key === 'Escape') {
        event.preventDefault(); close(); input?.focus();
      } else if (index >= 0 && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
        event.preventDefault();
        const next = index + (event.key === 'ArrowDown' ? 1 : -1);
        if (next < 0) input?.focus();
        else links[Math.min(next, links.length - 1)]?.focus();
      }
    });
    document.addEventListener('click', (event) => {
      if (!searchWrap.contains(event.target)) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
    });
  }

  /* ---------- Live variant updates ---------- */
  const variantSelect = document.querySelector('[data-variant-select]');
  if (variantSelect) {
    const sectionId = variantSelect.dataset.sectionId;
    const jsonTag = document.getElementById('ProductVariants-' + sectionId);
    let variants = [];
    try {
      variants = JSON.parse(jsonTag ? jsonTag.textContent : '[]');
    } catch (error) {
      variants = [];
    }
    const priceBox = document.querySelector('[data-product-price]');
    const stockBox = document.querySelector('[data-stock-status]');
    const addButton = document.querySelector('[data-add-button]');
    const mobilePrice = document.querySelector('[data-mobile-atc-price]');
    const mobileButton = document.querySelector('[data-mobile-atc-button]');
    const productGallery = document.querySelector('[data-product-gallery]');
    const mediaMapTag = document.getElementById('VariantMediaMap-' + sectionId);
    let variantMediaMap = [];
    try {
      variantMediaMap = JSON.parse(mediaMapTag ? mediaMapTag.textContent : '[]');
    } catch (error) {
      variantMediaMap = [];
    }

    variantSelect.addEventListener('change', () => {
      const variant = variants.find((candidate) => String(candidate.id) === String(variantSelect.value));
      if (!variant) return;

      if (priceBox) {
        const current = priceBox.querySelector('.price__current');
        if (current) current.textContent = money(variant.price);
        const compare = priceBox.querySelector('.price__compare');
        const priceEl = priceBox.querySelector('.price');
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          if (compare) {
            compare.textContent = money(variant.compare_at_price);
            compare.hidden = false;
          }
          if (priceEl) priceEl.classList.add('price--sale');
        } else {
          if (compare) {
            compare.textContent = '';
            compare.hidden = true;
          }
          if (priceEl) priceEl.classList.remove('price--sale');
        }
      }
      if (stockBox) {
        stockBox.classList.toggle('stock-status--sold', !variant.available);
        let label = 'In stock and ready to dispatch';
        let low = false;
        if (!variant.available) {
          label = 'Currently sold out';
        } else if (typeof variant.inventory_quantity === 'number' && variant.inventory_management && variant.inventory_quantity > 0 && variant.inventory_quantity <= 5) {
          label = variant.inventory_quantity + ' in stock';
          low = true;
        }
        stockBox.classList.toggle('stock-status--low', low);
        stockBox.childNodes.forEach((node) => {
          if (node.nodeType === Node.TEXT_NODE) node.textContent = '';
        });
        stockBox.appendChild(document.createTextNode(label));
      }
      const notifyBox = document.querySelector('[data-notify-stock]');
      if (notifyBox) {
        notifyBox.hidden = variant.available;
        // Keep the manual enquiry tied to the selected variant, not the first one.
        const restockVariant = notifyBox.querySelector('[data-restock-variant]');
        if (restockVariant) restockVariant.value = (variant.title || 'Default Title') + ' — ' + variant.id;
      }
      [addButton, mobileButton].forEach((button) => {
        if (!button) return;
        button.disabled = !variant.available;
        button.textContent = variant.available ? 'Add to cart' : 'Sold out';
      });
      if (mobilePrice) mobilePrice.textContent = money(variant.price);
      const mediaEntry = variantMediaMap.find((entry) => String(entry.id) === String(variant.id));
      if (productGallery && mediaEntry && mediaEntry.media_id && typeof productGallery.showMedia === 'function') {
        productGallery.showMedia(mediaEntry.media_id);
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    });
  }

  /* ---------- Sticky mobile add-to-cart ---------- */
  const mobileBar = document.querySelector('[data-mobile-atc]');
  const mainAddButton = document.querySelector('[data-add-button]');
  if (mobileBar && mainAddButton && 'IntersectionObserver' in window) {
    const barButton = mobileBar.querySelector('[data-mobile-atc-button]');
    if (barButton) {
      barButton.addEventListener('click', () => {
        if (!mainAddButton.disabled) mainAddButton.click();
      });
    }
    const observer = new IntersectionObserver((entries) => {
      const visible = entries[0].isIntersecting;
      const isMobile = window.matchMedia('(max-width: 800px)').matches;
      mobileBar.hidden = visible || !isMobile;
    }, { rootMargin: '-90px 0px 0px 0px' });
    observer.observe(mainAddButton);
  }

  /* ---------- Recently viewed ---------- */
  const STORAGE_KEY = 'ch64:recently-viewed';
  const readHistory = () => {
    try {
      return JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
    } catch (error) {
      return [];
    }
  };
  const productSection = document.querySelector('[data-product-section][data-product-handle]');
  const currentHandle = productSection ? productSection.dataset.productHandle : null;
  if (currentHandle) {
    try {
      const history = readHistory().filter((handle) => handle !== currentHandle);
      history.unshift(currentHandle);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(history.slice(0, 12)));
    } catch (error) { /* storage unavailable */ }
  }

  const recentSection = document.querySelector('[data-recently-viewed]');
  if (recentSection) {
    const grid = recentSection.querySelector('[data-recently-viewed-grid]');
    const limit = Number(recentSection.dataset.limit) || 4;
    const handles = readHistory().filter((handle) => handle !== currentHandle).slice(0, limit);
    if (grid && handles.length) {
      Promise.all(handles.map((handle) =>
        fetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      )).then((products) => {
        const valid = products.filter(Boolean);
        if (!valid.length) return;
        valid.forEach((product) => {
          const card = document.createElement('article');
          card.className = 'product-card';
          const link = document.createElement('a');
          link.href = product.url;
          link.className = 'product-card__media';
          link.setAttribute('aria-label', product.title);
          if (product.featured_image) {
            const img = document.createElement('img');
            img.className = 'product-card__image product-card__image--primary';
            img.src = product.featured_image;
            img.alt = product.title;
            img.loading = 'lazy';
            link.appendChild(img);
          }
          const body = document.createElement('div');
          body.className = 'product-card__body';
          if (product.vendor) {
            const vendor = document.createElement('p');
            vendor.className = 'product-card__vendor';
            vendor.textContent = product.vendor;
            body.appendChild(vendor);
          }
          const title = document.createElement('h3');
          title.className = 'product-card__title';
          const titleLink = document.createElement('a');
          titleLink.href = product.url;
          titleLink.textContent = product.title;
          title.appendChild(titleLink);
          body.appendChild(title);
          const footer = document.createElement('div');
          footer.className = 'product-card__footer';
          const price = document.createElement('div');
          price.className = 'price';
          const current = document.createElement('span');
          current.className = 'price__current';
          current.textContent = money(product.price);
          price.appendChild(current);
          footer.appendChild(price);
          body.appendChild(footer);
          card.appendChild(link);
          card.appendChild(body);
          grid.appendChild(card);
        });
        recentSection.hidden = false;
      });
    }
  }

  /* ---------- Cart: auto-update on quantity change ---------- */
  document.querySelectorAll('.cart-layout input[name="updates[]"]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (form) form.submit();
    });
  });
})();

// v24.1: auto-apply collection filters (checkboxes apply instantly, price on change)
(() => {
  const filterForm = document.querySelector('[data-filter-form]');
  if (!filterForm) return;
  let applyTimer = null;
  const apply = (delay) => {
    window.clearTimeout(applyTimer);
    applyTimer = window.setTimeout(() => filterForm.submit(), delay);
  };
  filterForm.querySelectorAll('input[type="checkbox"]').forEach((box) => {
    box.addEventListener('change', () => apply(320));
  });
  filterForm.querySelectorAll('input[type="number"]').forEach((field) => {
    field.addEventListener('change', () => apply(650));
  });
})();

// v24.2: quantity steppers (product + cart). Dispatches 'change' so the cart auto-updates.
document.addEventListener('click', (event) => {
  const minus = event.target.closest('[data-qty-minus]');
  const plus = event.target.closest('[data-qty-plus]');
  if (!minus && !plus) return;
  const stepper = (minus || plus).closest('.qty-stepper');
  const input = stepper ? stepper.querySelector('input[type="number"]') : null;
  if (!input) return;
  const min = input.min !== '' ? Number(input.min) : 0;
  let value = Number(input.value) || 0;
  value = plus ? value + 1 : value - 1;
  if (value < min) value = min;
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// v24.3: search icon opens a full-width search panel on phones/tablets.
(() => {
  const toggle = document.querySelector('[data-search-toggle]');
  const wrap = document.querySelector('.header-search-wrap');
  if (!toggle || !wrap) return;
  const input = wrap.querySelector('input[type="search"]');

  const isOverlayMode = () => window.getComputedStyle(wrap).position === 'absolute';
  const setOpen = (open) => {
    wrap.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    if (open && input) window.setTimeout(() => input.focus(), 40);
  };

  toggle.addEventListener('click', (event) => {
    if (!isOverlayMode()) return; // desktop: bar is inline, link not shown anyway
    event.preventDefault();
    setOpen(!wrap.classList.contains('is-open'));
  });

  document.addEventListener('click', (event) => {
    if (!wrap.classList.contains('is-open')) return;
    if (wrap.contains(event.target) || toggle.contains(event.target)) return;
    setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && wrap.classList.contains('is-open')) setOpen(false);
  });

  // Close the panel when the mobile menu opens (avoid stacked overlays)
  const navToggle = document.querySelector('.nav-toggle');
  if (navToggle) navToggle.addEventListener('click', () => setOpen(false));
})();

// Product image lightbox and back-to-top. Both respect reduced motion.
(() => {
  // Products and browsing content remain visible immediately while scrolling.

  /* ---------- Product image lightbox ---------- */
  const productImages = document.querySelectorAll('.product-gallery__image');
  if (productImages.length) {
    let lightbox = null;
    let lastFocus = null;
    const closeLightbox = () => {
      if (!lightbox) return;
      lightbox.remove();
      lightbox = null;
      document.body.classList.remove('lightbox-open');
      if (lastFocus) lastFocus.focus();
    };
    const openLightbox = (sourceImage) => {
      lastFocus = document.activeElement;
      lightbox = document.createElement('div');
      lightbox.className = 'product-lightbox';
      lightbox.setAttribute('role', 'dialog');
      lightbox.setAttribute('aria-modal', 'true');
      lightbox.setAttribute('aria-label', 'Enlarged product image');
      const img = document.createElement('img');
      img.src = sourceImage.currentSrc || sourceImage.src;
      img.alt = sourceImage.alt || '';
      const close = document.createElement('button');
      close.className = 'product-lightbox__close';
      close.setAttribute('aria-label', 'Close enlarged image');
      close.innerHTML = '&times;';
      close.addEventListener('click', closeLightbox);
      lightbox.addEventListener('click', (event) => {
        if (event.target === lightbox) closeLightbox();
      });
      lightbox.appendChild(img);
      lightbox.appendChild(close);
      document.body.appendChild(lightbox);
      document.body.classList.add('lightbox-open');
      close.focus();
    };
    productImages.forEach((image) => {
      image.classList.add('is-zoomable');
      image.setAttribute('tabindex', '0');
      image.setAttribute('role', 'button');
      image.setAttribute('aria-label', 'Tap to enlarge image');
      image.addEventListener('click', () => openLightbox(image));
      image.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); openLightbox(image); }
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeLightbox();
    });
  }

})();


// v30.5: sorting preserves the full current URL (search terms, brand, filters)
// and only swaps the sort value — a lost-parameter 404 is no longer possible.
document.querySelectorAll('[data-sort-select]').forEach((select) => {
  select.addEventListener('change', () => {
    // Immediate visible feedback: a full-page navigation follows, and without
    // this, shoppers see nothing happen for a moment and assume it needs
    // another click.
    select.disabled = true;
    select.classList.add('is-sorting');
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      url.searchParams.delete('page'); // sorting restarts from page 1
      window.location.assign(url.toString());
    } catch (error) {
      select.disabled = false;
      select.classList.remove('is-sorting');
      const form = select.closest('form');
      if (form) form.submit(); // fallback: hidden inputs carry the context
    }
  });
});

// v31: "Get in touch" opens the existing Shopify Inbox chat widget.
// The widget lives inside a shadow DOM, so we locate its real button and click it.
// If it is unavailable (still loading, app disabled, blocked), we show a short hint instead.
(() => {
  const triggers = document.querySelectorAll('[data-open-chat]');
  if (!triggers.length) return;

  const findChatButton = () => {
    const host = document.querySelector('inbox-online-store-chat');
    if (host && host.shadowRoot) {
      const candidate = host.shadowRoot.querySelector('button, [role="button"]');
      if (candidate) return candidate;
    }
    return document.querySelector('#ShopifyChat button, #ShopifyChat [role="button"], .shopify-chat-trigger');
  };

  const tryOpen = (attemptsLeft, onFail) => {
    const button = findChatButton();
    if (button) {
      button.click();
      return;
    }
    if (attemptsLeft <= 0) {
      onFail();
      return;
    }
    window.setTimeout(() => tryOpen(attemptsLeft - 1, onFail), 350);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const hint = document.querySelector('[data-chat-hint]');
      tryOpen(4, () => { if (hint) hint.hidden = false; });
    });
  });
})();

// Native browser validation must reveal an optional field if it is invalid.
document.addEventListener('invalid', (event) => {
  const details = event.target.closest?.('.collector-enquiry-extra');
  if (details) details.open = true;
}, true);

// v34.2.0 — optional guide calculator; no requests, storage or catalogue writes.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-scale-calculator]').forEach((calculator) => {
    const length = calculator.querySelector('[data-real-length]');
    const scale = calculator.querySelector('[data-model-scale]');
    const result = calculator.querySelector('[data-scale-result]');
    if (!length || !scale || !result) return;
    const update = () => {
      const realLength = Number(length.value);
      const denominator = Number(scale.value);
      if (!length.value.trim() || !length.validity.valid || ![18, 24, 43, 64, 87].includes(denominator)) {
        result.textContent = 'Enter a real-car length from 1,000 to 30,000 mm.';
        return;
      }
      const mm = realLength / denominator;
      result.textContent = `Estimated model length: ${mm.toFixed(1)} mm (${(mm / 10).toFixed(2)} cm) at 1:${denominator}.`;
    };
    length.addEventListener('input', update);
    scale.addEventListener('change', update);
    update();
  });
});
